import { render, staticRenderFns } from "./TrainingPricePlans.vue?vue&type=template&id=25a33394&"
import script from "./TrainingPricePlans.vue?vue&type=script&lang=js&"
export * from "./TrainingPricePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports